import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {MenuFormType} from "../../../store/menu/forms";
import {localize} from "../../../../../common/libs";
import {SnackbarType} from "../../../../../stores/common";
import style from "./../style.module.css";

const DeleteMenuCategoryForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const { menuStore, generalStore } = useStores();
    const forms = menuStore.forms;
    const { open, current } = forms.forms[MenuFormType.deleteMenuCategory];
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (!current) return null;

    const submitDelete = async (e: React.MouseEvent) => {

        e.preventDefault();
        e.stopPropagation();

        if(!current) return;

       await menuStore.removeCategory(current.menuId, current.id);
       generalStore.showSnackbar({
           title: t("menu:menuEditor.categorySuccessfullyDeleted"),
           type: SnackbarType.success
       });
       menuStore.forms.closeForm(MenuFormType.deleteMenuCategory);
       menuStore.forms.closeForm(MenuFormType.createMenuCategory);
        }





    return (
        <Dialog
            open={open}
            onClose={() => {
                menuStore.forms.closeForm(MenuFormType.deleteMenuCategory)
            }
            }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" className={style.deleteContent}>
                {t("menu:deleteMenuCategory")}
            </DialogTitle>
            <DialogContent className={style.deleteContent}>
                {t("menu:youGoingRemoveMenuCategory")} '{localize(current.data.name)}'.
                <br/>
                {t("menu:itIsUndone")}

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        menuStore.forms.closeForm(MenuFormType.deleteMenuCategory)
                    }}
                    color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="default"
                    onClick={submitDelete}
                >
                    {t("menu:modifiersSet.wantDelete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteMenuCategoryForm);


